import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';
import { Search as SearchActions } from 'client/actions';
import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

import Navbar from 'client/components/Navbar';
import NavbarButton from 'client/components/NavbarButton';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
@withApiState({
  resultsCountApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
  },
})
@branch({
  searchFilters: ['search', 'filters'],
  resultsCount: ['search', 'resultsCount'],
})
class FilterRentPriceRangePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: 'Search Filters',
  });

  static propTypes = {
    searchFilters: PropTypes.object.isRequired,
    resultsCount: PropTypes.number,
    resultsCountApiState: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { searchFilters } = props;

    this.state = {
      minRentPrice: searchFilters.minRentPrice,
      maxRentPrice: searchFilters.maxRentPrice,
    };
  }

  _onChangeRentPrice = (filterKey, filterValue) => {
    const updates = {
      [filterKey]: filterValue,
    };

    this.setState(updates);

    if (this._isValidForm({ ...this.state, ...updates })) {
      this.props.dispatch(SearchActions.updateFilter, {
        filterKey,
        filterValue,
      });
    }
  };

  _isValidForm = ({ minRentPrice, maxRentPrice }) => {
    return maxRentPrice > minRentPrice;
  };

  _onSubmit = () => {
    const { history } = this.props;
    history.push('/search');
  };

  render() {
    const { history, resultsCountApiState, resultsCount } = this.props;
    const { minRentPrice, maxRentPrice } = this.state;

    return (
      <div className="modal specificFilter">
        <div className="rentPriceRange">
          <div className="modal filters specificFilter">
            <Navbar
              leftButton={
                <NavbarButton onClick={() => history.push('/search')}>Cancel</NavbarButton>
              }
            />
            <div className="contentContainer">
              <span className="headline">Price Range</span>

              <div className="values">
                <SrFormikField
                  formField={{
                    id: 'minRentPrice',
                    title: 'Min.',
                    properties: {
                      placeholder: 'min.',
                      pattern: '[0-9]*',
                      onChange: (newValue) => {
                        this._onChangeRentPrice('minRentPrice', newValue);
                      },
                    },
                    type: 'currency',
                  }}
                  value={minRentPrice}
                />
                <SrFormikField
                  formField={{
                    id: 'maxRentPrice',
                    title: 'Max.',
                    properties: {
                      placeholder: 'max',
                      pattern: '[0-9]*',
                      onChange: (newValue) => {
                        this._onChangeRentPrice('maxRentPrice', newValue);
                      },
                    },
                    type: 'currency',
                  }}
                  value={maxRentPrice}
                />
              </div>

              <div className="saveFilterContainer">
                <ButtonDeprecated
                  theme={BUTTON_THEME_BLUE}
                  onClick={this._onSubmit}
                  disabled={!this._isValidForm({ minRentPrice, maxRentPrice })}
                >
                  {resultsCountApiState.isLoading
                    ? 'please wait...'
                    : typeof resultsCount === 'number'
                    ? `done (${resultsCount} ${pluralize('match', resultsCount)})`
                    : 'done'}
                </ButtonDeprecated>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterRentPriceRangePage.displayName = 'FilterRentPriceRangePage';

export default FilterRentPriceRangePage;
